module.exports = __webpack_public_path__ + "img/banner.b2ec1c41.png";